module.exports = __webpack_public_path__ + "static/img/banner-title-old.dc6ca38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-title-old.png
// module id = qVWJ
// module chunks = 1